
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarTargetAcquisitionStateAutoIec as ObiRadarTargetAcquisitionStateAutoIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-target-acquisition-state-auto-iec.js';
 
 
 

 
 export const ObiRadarTargetAcquisitionStateAutoIec = createComponent({
   react: React,
   tagName: 'obi-radar-target-acquisition-state-auto-iec',
   elementClass: ObiRadarTargetAcquisitionStateAutoIecElement,
   events: {
     
   }
  });
 
 